// 全局的监听事件
import React, { useEffect, useRef } from "react";
import _ from 'lodash';
import { useNavigate } from "react-router-dom";
import EventEmitter from '@/utils/eventEmitter';
import { getLoginToken } from '@/utils/localStorage';
import { getLobFromToken } from '@/utils/utils';
import message_receive from '@/assets/audio/message_receive.mp3';
import {EAP_SCALE_PACKAGE_SCENE_ID} from '@/Constant';

// 路径判断工具函数
const shouldSkipNavigation = (pathname) => {
  // 需要跳过跳转的路径列表
  const skipPaths = [
    '/psychological-test-user-form',
    '/safety-test-user-form',
    '/client/safety-ai-report',
    '/client/staff-task-iframe',
    '/client/diy-doll-group/doll-report-detail',
    '/client/diy-doll-group/doll-group-report'
  ];
  
  return skipPaths.some(path => pathname.includes(path));
};

// 获取目标路由的函数
const getTargetRoute = (pathname, baseRoute, queryParams = '') => {
  if (pathname.includes('safety')) {
    return `/client/safety-${baseRoute}${queryParams}`;
  }
  return `/client/${baseRoute}${queryParams}`;
};

export default function Listener() {
  const navigate = useNavigate();
  const audioRef = useRef(null);

  let throttled = _.throttle(() => {
    const audio = audioRef.current;
    audio.muted = true; // 静音播放
    audio.play().then(() => {
    audio.muted = false; // 取消静音
    }).catch(error => {
      console.error('自动播放失败:', error);
    });
  }, 5000, { leading: true, trailing: false });

  useEffect(() => {
    // 判断是否是微信浏览器
    const isWeixin = () => {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    }
    const isWeixinBrowser = isWeixin();
    if (isWeixinBrowser) {
      // 微信浏览器自动播放音频
      document.addEventListener('WeixinJSBridgeReady', function () {
        const audioElement = document.getElementById('audio-div');
        // audioElement.volumn = 1;
        audioElement.muted = false;
      }, false);
    }
    else {
      // 非微信浏览器自动播放音频
      document.body.addEventListener('touchend', function () {
        const audioElement = document.getElementById('audio-div');
        // audioElement.volumn = 1;
        audioElement.muted = false;
      }, false);
    }
  }, [])

  // 监听事件
  useEffect(() => {
    const handleFormEnd = (val) => {
      const lob = getLobFromToken(getLoginToken('patient'));
      // 国药用户跳转到专属关爱页面
      if (lob === 'SFDA') {
        navigate('/client/sfda-exclusive-love', { state: val });
        return
      }
      
      const pathname = window.location.pathname;
      
      // 检查是否需要跳过导航
      if (shouldSkipNavigation(pathname)) {
        return;
      }
      
      // 根据路径决定跳转到哪个列表页
      const sceneId = val?.sceneId;
      let targetRoute = '';
      if (EAP_SCALE_PACKAGE_SCENE_ID.includes(sceneId)) {
        // 会生成AI报告
        targetRoute = getTargetRoute(pathname, 'form-task-list', '?showAIReport=loading');
      } else {
        targetRoute = getTargetRoute(pathname, 'form-task-list', );
      }
      navigate(targetRoute, { replace: true });
    }

    EventEmitter.on('STAFF_FORM_TASK_SUCCESS', handleFormEnd);
    return () => {
      EventEmitter.removeListener('STAFF_FORM_TASK_SUCCESS', handleFormEnd);
    }
  }, [navigate]);

  // // 监听事件 - AI报告
  // useEffect(() => {
  //   const handleAIReport = (val) => {
  //     const pathname = window.location.pathname;
      
  //     // 检查是否需要跳过导航
  //     if (shouldSkipNavigation(pathname)) {
  //       return;
  //     }
      
  //     // 根据路径决定跳转到哪个列表页并带上AI报告参数
  //     const targetRoute = getTargetRoute(pathname, 'ai-report-transition');
  //     navigate(targetRoute, { replace: true });
  //   }

  //   EventEmitter.on('STAFF_FORM_TASK_AI_REPORT', handleAIReport);
  //   return () => {
  //     EventEmitter.removeListener('STAFF_FORM_TASK_AI_REPORT', handleAIReport);
  //   }
  // }, [])

  /**
   *提示音的播放逻辑
    * 1. 当前页面是聊天页面，不播放提示音
    * 2. 当前页面不是聊天页面，播放提示音
    * 3. 当前页面不是聊天页面，但是有未读消息，播放提示音
    * 4. 如果收到不同设备，但是是同一个用户发来的消息，不播放提示音
   */
  // 增加来消息的提示音
  useEffect(() => {
    const handleNewMessage = (data) => {
      throttled();
    }
    EventEmitter.on('UPDATE_UNREAD_MESSAGE', handleNewMessage);
    return () => {
      EventEmitter.removeListener('UPDATE_UNREAD_MESSAGE', handleNewMessage);
    }
  }, [])

  return (
    <audio src={message_receive} id="audio-div" ref={audioRef}></audio>
  )
}

